var map = {
	"./cancel.svg": "TIr6",
	"./envelope.svg": "7KnO",
	"./power.svg": "KSUw",
	"./print.svg": "gcG/",
	"./refresh.svg": "mM5X",
	"./sticker.svg": "DeWl",
	"./table-horizontal.svg": "BS7e",
	"./window.svg": "IgQo"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hGTH";